import { useState } from "react";
import { Helmet } from "react-helmet";
import BackButton from "../components/BackButton";

export default function ImageToBase64() {
  const [image, setImage] = useState(null);
  const [base64, setBase64] = useState("");

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImage(URL.createObjectURL(file));

    const reader = new FileReader();
    reader.onloadend = () => {
      setBase64(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(base64).then(() => {
      alert("Base64 copied to clipboard!");
    });
  };

  return (
    <>
      <Helmet>
        <title>Image to Base64 Converter - Free Online Tool for PNG, JPG & More</title>
        <meta
          name="description"
          content="Convert your image files (PNG, JPG, or others) to Base64 online instantly. Easy to use, free converter to get Base64 code for your images."
        />
        <meta name="keywords" content="image to base64, base64 converter, convert image to base64, png to base64, jpg to base64, online base64 tool" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://freelity.com/image-to-base64" />
      </Helmet>

      <section className="sec-free-tools">
        <div className="container">
          <BackButton />
          <h2>Image to Base64 Converter</h2>

          <input
            type="file"
            accept="image/*"
            className="form-control mb-3"
            onChange={handleImageUpload}
          />

          {image && (
            <div className="text-center mb-4">
              <img src={image} alt="Preview" className="img-fluid mb-3" style={{ maxHeight: "300px" }} />
            </div>
          )}

          {base64 && (
            <>
              <textarea
                className="form-control mb-3"
                rows="8"
                readOnly
                value={base64}
              />
              <button className="btn btn-success" onClick={handleCopy}>
                Copy Base64
              </button>
            </>
          )}
        </div>
      </section>
    </>
  );
}
